import axios from 'axios';
import router from '../../router/routes';
import notify from './notify';
import store from '../store';

export default function destroyPopulationData(axiosRoute, fieldId) {
    store.commit('overlay/toggle', true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .post(axiosRoute)
            .then((response) => {
                notify(response.data.message, 'success');
                router.push('/field/edit/' + fieldId);
                resolve(true);
            })
            .catch((error) => {
                notify(error.response.data.message, 'error');
                store.commit('overlay/toggle', false, { root: true });
                reject(false);
            });
    });
}
